import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import Block, { BlockContent, BlockGrid } from "~/components/Block";
import Card from "~/components/Card";
import { StoryDocument } from "~/external/v2/types";

type StoriesOverviewProps = {
  spacingTop?: number;
  spacingBottom?: number;
  backgroundColor?: string;
  highlightColor?: string;
  color?: string;
  animateIn?: boolean;

  // maximumStories: number;
  columnsOnMobile: number;
  columnsOnDesktop: number;

  merged: { stories: StoryDocument[] };
};

const variants = {
  out: { opacity: 0, y: "100%" },
  in: {
    opacity: 1,
    y: 0,
    transition: {
      type: "tween",
      ease: [0.23, 1, 0.32, 1],
      duration: 2,
    },
  },
};

export default function StoriesOverview(props: StoriesOverviewProps) {
  const {
    spacingTop = 0,
    spacingBottom = 6,
    highlightColor,
    color,
    backgroundColor,
    animateIn = false,

    // maximumStories = 5,
    columnsOnMobile = 1,
    columnsOnDesktop = 3,

    merged = { stories: [] },
  } = props;

  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  let animate = inView ? "in" : "out";
  if (!animateIn) {
    animate = "in";
  }

  return (
    <Block
      spacingTop={spacingTop}
      spacingBottom={spacingBottom}
      backgroundColor={backgroundColor}
      color={color}
    >
      <BlockContent ref={ref}>
        <motion.div variants={variants} animate={animate}>
          <BlockGrid columnsOnMobile={columnsOnMobile} cols={columnsOnDesktop}>
            {merged.stories.map((item, i) => (
              <Card
                key={i}
                title={item.data.title}
                subtitle={item.data.category.uid} // TODO: Get title
                href={`/stories/${item.data.category.uid}/${item.uid}`}
                media={
                  item.data.cover_image &&
                  item.data.cover_image.url && [
                    item.data.cover_image.url,
                    "image",
                    item.data.cover_image.dimensions.width,
                    item.data.cover_image.dimensions.height,
                    item.data.cover_image.alt,
                  ]
                }
              />
            ))}
          </BlockGrid>
        </motion.div>
      </BlockContent>
    </Block>
  );
}
